import React, { useEffect, useState } from "react";
import { Dialog, Loading } from "@actinc/dls";
import HtmlDiff from "htmldiff-js";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useClient } from "urql";

const CompareReferencePassageDialog = ({
  closeOptions,
  onClose,
  open,
  passageID,
}) => {
  const client = useClient();
  const [transformedPassage, setTransformedPassage] = useState();
  const [diff, setDiff] = useState();

  useEffect(() => {
    client
      .query(getTransformedPassageContentQuery, { ids: [passageID] })
      .toPromise()
      .then((response) => {
        setTransformedPassage(
          response.data?.getTransformedPassageContent.at(0),
        );
      });
  }, []);

  useEffect(() => {
    if (
      !transformedPassage ||
      !transformedPassage.content ||
      !transformedPassage.referenceContent
    )
      return;

    const result = HtmlDiff?.execute(
      transformedPassage.content,
      transformedPassage.referenceContent,
    );
    setDiff(result);
  }, [transformedPassage]);

  const handleClose = (value) => () => {
    onClose(value);
  };

  return (
    <Dialog maxWidth="sm" onClose={handleClose(false)} open={open}>
      <DialogTitle>Reference Passage Comparison</DialogTitle>
      <DialogContent>
        {!transformedPassage && <Loading />}
        {transformedPassage && !transformedPassage.referenceContent && (
          <div>Reference Passage is not Created</div>
        )}
        <Box
          dangerouslySetInnerHTML={{ __html: diff }}
          sx={{
            ".qti-visually-hidden": {
              position: "fixed !important",
              overflow: "hidden",
              clip: "rect(1px 1px 1px 1px)",
              height: "1px",
              width: "1px",
              border: 0,
              margin: "-1px",
            },
            "ins.diffins,ins.diffmod": {
              backgroundColor: "#e5ffcd !important",
              display: "inline !important",
              textDecoration: "none",
            },
            "del.diffdel,del.diffmod": {
              backgroundColor: "#e8e8e8 !important",
              color: "#555 !important",
              display: "inline !important",
              textDecoration: "line-through !important",
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        {closeOptions.includes("close") && (
          <Button
            color="primary"
            onClick={handleClose(false)}
            variant="contained"
          >
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

const getTransformedPassageContentQuery = `
  query getTransformedPassageContent($ids: [ID!]!, $items: [ID!]) {
    getTransformedPassageContent(ids: $ids, items: $items) {
      id
      content
      referenceContent
    }
  }
`;

export { CompareReferencePassageDialog };
